"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MotionFlex = _interopRequireDefault(require("../motionComponents/MotionFlex/MotionFlex"));

var _Overlay = _interopRequireDefault(require("../Overlay/Overlay"));

var _utils = _interopRequireDefault(require("../../utils"));

var _excluded = ["onToggle", "children", "noOverlay", "width", "animated", "overlayProps", "maxWidth", "disableScrollbar", "zIndex"];
var ModalWrapper = (0, _styledComponents["default"])(_MotionFlex["default"]).withConfig({
  displayName: "Modal__ModalWrapper",
  componentId: "sc-if1nqb-0"
})(["overflow:auto;border-radius:4px;box-shadow:0 11px 15px -7px rgba(0,0,0,0.2),0 24px 38px 3px rgba(0,0,0,0.14),0 9px 46px 8px rgba(0,0,0,0.12);width:90%;@media screen and (min-width:", "px){width:", ";}@media screen and (min-width:", "px){max-width:", "px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints[0];
}, function (_ref2) {
  var width = _ref2.width;
  return width;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints[1];
}, function (_ref4) {
  var maxWidth = _ref4.maxWidth;
  return maxWidth;
});
var animatedOverlayVariants = {
  hidden: {
    opacity: 0,
    transition: {
      delay: 0.2
    }
  },
  visable: {
    opacity: 1
  }
};
var animatedOverlayProps = {
  variants: animatedOverlayVariants,
  initial: "hidden",
  animate: "visable",
  exit: "hidden",
  key: "overlay"
};
var animateProps = {
  transition: {
    delay: 0.2,
    duration: 0.4,
    type: "spring"
  },
  initial: {
    y: 1000
  },
  animate: {
    y: 0
  },
  exit: {
    y: 1000
  }
};

var Modal = function Modal(_ref5) {
  var onToggle = _ref5.onToggle,
      children = _ref5.children,
      noOverlay = _ref5.noOverlay,
      width = _ref5.width,
      _ref5$animated = _ref5.animated,
      animated = _ref5$animated === void 0 ? false : _ref5$animated,
      overlayProps = _ref5.overlayProps,
      maxWidth = _ref5.maxWidth,
      disableScrollbar = _ref5.disableScrollbar,
      zIndex = _ref5.zIndex,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref5, _excluded);
  var overlayPropsToPassIn = animated ? (0, _extends2["default"])({}, animatedOverlayProps, overlayProps) : overlayProps;
  var modalPropsToPassIn = animated ? (0, _extends2["default"])({}, animateProps, props) : props;
  return /*#__PURE__*/_react["default"].createElement(_Overlay["default"], (0, _extends2["default"])({
    onClick: onToggle,
    bg: noOverlay ? "transparent" : undefined,
    zIndex: zIndex
  }, overlayPropsToPassIn), /*#__PURE__*/_react["default"].createElement(ModalWrapper, (0, _extends2["default"])({
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    maxWidth: maxWidth,
    width: width
  }, modalPropsToPassIn), disableScrollbar && /*#__PURE__*/_react["default"].createElement(_utils["default"].DisableScroll, {
    reserveScrollBarGap: true
  }), children));
};

Modal.defaultProps = {
  noOverlay: false,
  maxWidth: 560,
  width: "50%"
};
Modal.propTypes = (0, _extends2["default"])({}, _MotionFlex["default"].propTypes, {
  onToggle: _propTypes["default"].func.isRequired,
  noOverlay: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string, _propTypes["default"].node]).isRequired,
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
});
var _default = Modal;
exports["default"] = _default;